import * as Sentry from '@sentry/react';

export const reportDataOperationError = (error, { operation, collectionPath, context = {} } = {}) => {
  Sentry.captureException(error, {
    tags: {
      area: 'data-operation',
      operation: operation || 'unknown'
    },
    extra: {
      collectionPath,
      ...context
    }
  });
};
